import { useEffect, useState } from 'react';
import { Header, Table, Groupper, Label, Toolbar } from 'react-frontier';
import { useParams } from 'react-router-dom';
import { useBreadcrumbs, useUser } from '../Hooks';
import { UserClass, SetLoading } from '../SiteClasses';
import { formatUnix } from '../SiteUtil';
import UserAccess from '../UserAccess';
import UserAccessConfig from '../components/UserAccessConfig';
import Toast from '../Toast';
import API from '../API';

var UserView = ()=>{
	var params = useParams<{ user_id: string }>();
	var { hasAccess, user } = useUser();
	var { setTitle } = useBreadcrumbs();
	var [loadError, setLoadError] = useState<string>(null);
	var [userData, setUserData] = useState<UserClass>(null);
	var [access, setAccess] = useState<number[]>([]);
	var [errorPrompts, setErrorPrompts] = useState<string[]>(null);

	useEffect(()=>{
		var id = parseInt(params.user_id);
		setTitle('Usuario #'+id);
		API.getUser(id).then(res=>{
			if(res.error) return setLoadError(res.message);
			setUserData(res.data);
			setAccess(res.data.access || []);
		}).catch(()=>{
			setLoadError('Hubo un error cargando el usuario (LCL-1)');
		});
	}, []);

	var updateAccess = (setLoading: SetLoading)=>{
		setErrorPrompts(null);
		setLoading(true);
		API.userAccess(userData.user_id, access).then(res=>{
			if(res.error) return setErrorPrompts([res.message]);
			Toast.success('Permisos actualizados');
			setUserData(prev=>({ ...prev, access }));
		}).catch(()=>{
			setErrorPrompts(['Hubo un error inesperado actualizando los permisos (U-UPD-1)']);
		}).finally(()=>{
			setLoading(false);
		});
	};

	var toggleSuperadmin = ()=>{
		var superadmin = !userData.superadmin;
		API.setUserSuperadmin(userData.user_id, superadmin).then(res=>{
			if(res.error) return Toast.error(res.message);
			Toast.success(superadmin ? 'Usuario marcado como superadmin' : 'Superadmin removido');
			setUserData(prev=>({ ...prev, superadmin }));
		}).catch(()=>{
			Toast.error('Hubo un error inesperado actualizando el usuario (U-SPA-1)');
		});
	};

	if(loadError) return <Header text='Error' subtext={loadError} />;
	if(!userData) return <Header text='Cargando datos' loading />;

	return <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
		<Groupper title='Información de usuario' style={{ width: 500, marginTop: 20 }} fitted>
			{user?.superadmin && (
				<Toolbar stretch>
					<Toolbar.Item
						text={userData.superadmin ? 'Quitar superadmin' : 'Marcar como superadmin'}
						iconName={userData.superadmin ? 'user-minus' : 'user-shield'}
						onClick={toggleSuperadmin}
					/>
				</Toolbar>
			)}
			<Table details striped>
				<Table.Row data={['ID', userData.user_id]} />
				<Table.Row data={['Nombre', `${userData.first_name} ${userData.last_name}`]} />
				<Table.Row data={['Correo electrónico', userData.email]} />
				<Table.Row data={['Estado', <Label color={userData.active ? 'green' : 'red'}>{userData.active ? 'Activo' : 'Inactivo'}</Label>]} />
				<Table.Row data={['Creado', formatUnix(userData.date_created, 'dd/MMM/yyyy HH:mm')]} />
			</Table>
		</Groupper>
		{userData.superadmin ? (
			<Groupper title='Permisos' style={{ width: 500, marginTop: 20 }}>
				<Header text='Usuario superadmin' subtext='Este usuario es superadmin y puede realizar todo en el sistema.' />
			</Groupper>
		) : hasAccess(UserAccess.USERS.EDIT_ACCESS) ? (
			<UserAccessConfig
				accesss={access}
				onAccessChange={setAccess}
				width={500}
				style={{ marginTop: 20, marginBottom: 40 }}
				errorPrompts={errorPrompts}
				onClick={updateAccess}
			/>
		) : null}
	</div>;
}

export default UserView;
